export default "__VITE_ASSET__DZpE4Rbm__"